module.exports = __webpack_public_path__ + "media/images/fake_courses/test1-be336397e19ee3e4567da19900909fc3.jpg";